import { render, staticRenderFns } from "./DistrictPriceList.vue?vue&type=template&id=2348cda6&scoped=true&"
import script from "./DistrictPriceList.vue?vue&type=script&lang=js&"
export * from "./DistrictPriceList.vue?vue&type=script&lang=js&"
import style0 from "./DistrictPriceList.vue?vue&type=style&index=0&id=2348cda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2348cda6",
  null
  
)

export default component.exports